export const projectConfig = {
  port: 4500,
  host: 'localhost',
};
